export default __webpack_public_path__ + "43da2e95e7e77c5c2c53dfc0f9c0a005.gif";